import React, { Component } from 'react';
import { logError } from '../logger';

export interface ErrorBoundaryState {
  hasError: boolean;
}

type Props = any;

class ErrorBoundary extends Component<Props, ErrorBoundaryState> {
  constructor(props: Props) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidCatch(error?: Error): void {
    const message = (error && (error as Error)?.message) || 'Unknown';

    logError(`Component render failed with error: ${message}`);

    this.setState({
      hasError: true,
    });
  }

  render(): React.JSX.Element | null {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      // TODO fallback when component fails
      return null;
    }

    return <>{children}</>;
  }
}

export default ErrorBoundary;
